import UserTableFilter from "./user-table-filter";


const UserFilters = {
    Table: UserTableFilter,
}

export default UserFilters;